import * as types from './actionsTypes';

export type SaveGradesActionType = {
  type: string;
  esrogId: number;
  grades: string;
  headers: any;
  onSuccess?: () => void;
};

export const saveGradesAction = (
  esrogId: number,
  grades: string,
  headers: any,
  onSuccess?: () => void
): SaveGradesActionType => ({
  type: types.SAVE_GRADES,
  esrogId,
  grades,
  headers,
  onSuccess,
});
